jQuery(function () {
  if (window.SparkleConfig.env === "development") {
    return;
  }

  if (!/\/edit/i.test(window.location.pathname)) {
    return;
  }

  if (!(window.RESOURCE && window.RESOURCE.type && window.RESOURCE.id)) {
    return;
  }

  var interval;
  var minute = 60000;

  notify(); // Notify immediately
  interval = setInterval(notify, minute); // Notify every minute
  setTimeout(clearInterval, 180 * minute, interval); // Stop after 3 hours

  // HELPER FUNCTIONS

  function notify() {
    jQuery.ajax("/admin/current_edit", {
      type: "PUT",
      data: { resource_type: window.RESOURCE.type, resource_id: window.RESOURCE.id },
    });
  }
});
